import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { environment } from '../../../../../environments/environment';
import { BaseService } from '../../../shared/Services/BaseService';

@Injectable({
  providedIn: 'root'
})
export class PageRolesService extends BaseService {

  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    const baseUrl = environment.apiUrl + 'Page';
    super(http, authenticationSerives, baseUrl);
  }
}
